module.exports = __webpack_public_path__ + "img/39-l.664b1340.png";